var map = {
	"./blue_flag.png": "d43b",
	"./clear_flag.png": "9dc2",
	"./cyan_flag.png": "c3e6",
	"./gray_flag.png": "a781",
	"./green_flag.png": "16c1",
	"./none_flag.png": "59aa",
	"./orange_flag.png": "07ce",
	"./purple_flag.png": "cdd1",
	"./red_flag.png": "2d18",
	"./yellow_flag.png": "5f50"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "749d";